import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reviewSent: {
    id: 'pd.reviews.review.sent',
    defaultMessage: 'Hodnocení odesláno',
  },
  reviewSentWithFailedImages: {
    id: 'pd.reviews.review.sent.withFailedImages',
    defaultMessage:
      'Hodnocení odesláno, ale některé fotky se nepodařilo nahrát.',
  },
  reviewSentThanks: {
    id: 'pd.reviews.review.sent.thanks',
    defaultMessage:
      'Děkujeme, že pomáháte ostatním zákazníkům s lepším výběrem',
  },
  reviewSendWithFailedImagesThanks: {
    id: 'pd.reviews.review.sent.withFailedImages.description',
    defaultMessage:
      'Děkujeme, že pomáháte ostatním zákazníkům s lepším výběrem. Omlouváme se, že se nám nepodařilo nahrát všechny vaše fotky.',
  },
  done: {
    id: 'pd.reviews.review.sent.done',
    defaultMessage: 'Hotovo',
  },
  infoLineSomeImagesFailed: {
    id: 'pd.reviews.review.sent.infoLine.someImagesFailed',
    defaultMessage: 'Některé fotky se nám bohužel nepodařilo nahrát.',
  },
  tryAgain: {
    id: 'pd.reviews.review.sent.infoLine.someImagesFailed.tryAgain',
    defaultMessage: 'Zkusit znovu',
  },
  continueReviewingTitle: {
    id: 'pd.reviews.review.sent.continue.title',
    defaultMessage: 'Pokračujte v hodnocení',
  },
  continueReviewingSubtitle: {
    id: 'pd.reviews.review.sent.continue.subtitle',
    defaultMessage: 'Jde vám to skvěle. Ohodnoťte další zakoupené produkty.',
  },
  writeReview: {
    id: 'pd.reviews.review.sent.continue.writeReviewButton',
    defaultMessage: 'Napsat recenzi',
  },
  myReviewsFooterText: {
    id: 'pd.reviews.review.sent.continue.myReviewsFooterText',
    defaultMessage:
      'Zakoupené produkty můžete kdykoli ohodnotit ve svém účtu v sekci <link>Moje recenze</link>',
  },
});
